import React from "react";
import useAppContext from "../Reducers";
import { Navigate, useLocation } from "react-router";

export const DynamicRoute = ({ children }) => {
  const {
    store: { isAuthenticated },
  } = useAppContext();
  let location = useLocation();

  const userAgent = window.navigator.userAgent;

  if (userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("Android") > -1) {
    return isAuthenticated ? (
      //<Layout children={children} />
      <div children={children} />
    ) : (
      <Navigate to="/mobile/login" state={{ from: location }} />
    );
  } else {
    ////console.log(isAuthenticated);
    return isAuthenticated ? (
      //<Layout children={children} />
      <div children={children} />
    ) : (
      <Navigate to="/login" state={{ from: location }} />
    );
  }
};
